/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const LicensingModel = Object.freeze({
  TRY_AND_BUY: 'TryAndBuy',
  SUBSCRIPTION: 'Subscription',
  RENTAL: 'Rental',
  FLOATING: 'Floating',
  MULTI_FEATURE: 'MultiFeature',
  PAY_PER_USE: 'PayPerUse',
  PRICING_TABLE: 'PricingTable',
  QUOTA: 'Quota',
  NODE_LOCKED: 'NodeLocked',
  DISCOUNT: 'Discount',
});

export default LicensingModel;
